module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\nDear forge administrator,\n\nThe mission of Software Heritage is to collect, preserve and share all\nthe publicly available source code (see\nhttps://www.softwareheritage.org for more information).\n\nWe just received a request to add the forge hosted at ")
    ; __append(escapeFn( forgeUrl ))
    ; __append("\nto the list of software origins that are archived, and it is our\nunderstanding that you are the contact person for this forge.\n\nIn order to archive the forge contents, we will have to periodically\npull the public repositories it contains and clone them into the\nSoftware Heritage archive.\n\nPlease let us know if there are any technical issues to consider before\n we launch the archival of the public repositories hosted on your\n infrastructure.(use \"Reply all\" to ensure our system will process \n your answer properly)\n\nIn the absence of an answer to this message, we will start to archive \nyour forge in the coming weeks (only the publicly accessible \nrepositories will be archived)\n\nThank you in advance for your help.\n\nKind regards,\nThe Software Heritage team\n")
  }
  return __output;

}